/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Font_Size_LabelInputs */

const en_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Size (px)`)
};

const fr_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de police (px)`)
};

const de_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße (px)`)
};

const it_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione carattere (px)`)
};

const ru_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта (пиксели)`)
};

const es_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente (px)`)
};

const zh_cn2_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体大小（像素）`)
};

const ja_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズ（ピクセル）`)
};

const hi_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट आकार (px)`)
};

const pt_pt2_edit_event_group_font_size_label = /** @type {(inputs: Edit_Event_Group_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da fonte (px)`)
};

/**
* | output |
* | --- |
* | "Font Size (px)" |
*
* @param {Edit_Event_Group_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_font_size_label = /** @type {((inputs?: Edit_Event_Group_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_font_size_label(inputs)
	if (locale === "de") return de_edit_event_group_font_size_label(inputs)
	if (locale === "it") return it_edit_event_group_font_size_label(inputs)
	if (locale === "ru") return ru_edit_event_group_font_size_label(inputs)
	if (locale === "es") return es_edit_event_group_font_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_font_size_label(inputs)
	if (locale === "ja") return ja_edit_event_group_font_size_label(inputs)
	if (locale === "hi") return hi_edit_event_group_font_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_font_size_label(inputs)
	return en_edit_event_group_font_size_label(inputs)
});